<script lang="ts" setup>
import { useClaims, useRefreshClaims } from '@auth/useClaims';
import { signOut } from '@auth/util';
import CrmBase from '@crm-lib/pages/CrmBase.vue';
import AppLayout from '@menu-lib/components/AppLayout/AppLayout.vue';
import useTimeout from '@services/base/useTimeout';
import VSessionTimeoutModal from '@shared/component/VSessionTimeoutModal/VSessionTimeoutModal.vue';
import VToast from '@shared/component/VToast/VToast.vue';
import { useRoute, useRouter } from 'vue-router';
import { computed, onMounted, ref } from 'vue';

const route = useRoute();
const routerReady = ref<boolean>(false);
const router = useRouter();

onMounted(async () => {
  await router.isReady();
  routerReady.value = true;
});

const isAuthenticatedRoute = computed(
  () => routerReady.value === true && route.meta.public !== true,
);

const claims = useClaims(isAuthenticatedRoute);
const { refresh } = useRefreshClaims();
const { isCloseToTimeout, isTimedOut, secondsUntilTimeout } = useTimeout();
</script>

<template>
  <div class="sb-app [--subheader-height:_54px]">
    <VToast />

    <div v-if="!isAuthenticatedRoute" class="p-8">
      <CrmBase />
    </div>

    <AppLayout v-else-if="claims?.isInitialLoading === false && claims?.isSuccess === true">
      <div class="flex grow">
        <div class="w-full">
          <CrmBase />
        </div>
      </div>

      <VSessionTimeoutModal
        :is-timedout="isTimedOut"
        :is-close-to-timeout="isCloseToTimeout"
        :seconds-until-timeout="secondsUntilTimeout"
        @handle-sign-out="signOut()"
        @continueSession="refresh()"
      />
    </AppLayout>
  </div>
</template>

<style>
@import '@assets/styles/app.css';
</style>
